// extracted by mini-css-extract-plugin
export var skeletonBlock = "skeletonBlock_NZJNx9jwQTfdhAje3cQf";